import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardBody } from 'reactstrap';

const PanelButton = ({ icon, onClick, isPrimary=false}) => {
    return (
        <Card className="text-center d-xs-12 d-sm-none" onClick={onClick} style={{backgroundColor:isPrimary?'#ba54f5':'#011e31'}}>
            <CardBody>
                <FontAwesomeIcon icon={icon} size="4x" color="white" />
            </CardBody>
        </Card>
    );
};

export default PanelButton;